module.exports = __webpack_public_path__ + "img/plane_track_2.ba6be2d7.svg";